// src/slices/post/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// ================= GET ALL POSTS WEBSITE =================
export const getPostsWebsite = createAsyncThunk("posts/getPostsWebsite", async (params, { rejectWithValue }) => {
  try {
    let queryParams = {};
    if (typeof params === 'object' && params !== null) {
      queryParams = params;
    } else if (params) {
      queryParams = { CategoryId: params };
    }
    const res = await axios.get(`${API_URL}/post/all`, { params: queryParams });

    return res;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
export const getTopViewedPosts = createAsyncThunk("posts/getTopViewedPosts", async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/post/top-viewed`);

    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
export const getPostsByCategory = createAsyncThunk("posts/getPostsByCategory", async (categoryId, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/post/all`, { params: { CategoryId: categoryId } });
    return { categoryId, data: res.data.data };
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
// ================= GET POST BY SLUG WEBSITE =================
export const getPostBySlugWebsite = createAsyncThunk("posts/getPostBySlugWebsite", async (slug, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/post/slug/${slug}`);

    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
// ================= GET ONE POST WEBSITE =================
export const getOnePostWebsite = createAsyncThunk("posts/getOnePostWebsite", async (identifier, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/post/one`, { params: { identifier } });

    return res.data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// ================= CREATE POST =================
export const createPost = createAsyncThunk("posts/createPost", async (data, { rejectWithValue }) => {
  try {
    const res = await axios.post(`${API_URL}/post`, data);

    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// ================= UPDATE POST =================
export const updatePost = createAsyncThunk("posts/updatePost", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await axios.put(`${API_URL}/post/${id}`, data);

    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// ================= DELETE POST =================
export const deletePost = createAsyncThunk("posts/deletePost", async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`${API_URL}/post/${id}`);

    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// ================= TOGGLE ACTIVE =================
export const togglePostStatus = createAsyncThunk("posts/togglePostStatus", async (id, { rejectWithValue }) => {
  try {
    const res = await axios.patch(`${API_URL}/post/toggle/${id}`);

    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
